<template>
  <div>
    <h1 class="modal-h1 mb-3">
      <button type="button"
              class="btn btn-back"
              @click="$emit('cancel')"
      />
      Create Mover
    </h1>
    <form @submit.prevent="create" @keydown="clearError($event)" autocomplete="no">
      <div class="l-bg-white">
        <div class="row mb-3">
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>First name</label>
              <input v-model="mover.first_name"
                     type="text"
                     placeholder="Enter First Name"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="first_name" />
          </div>
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>Last name</label>
              <input v-model="mover.last_name"
                     type="text"
                     placeholder="Enter Last Name"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="last_name" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>Email</label>
              <input v-model="mover.email"
                     type="email"
                     placeholder="Enter Email"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="email" />
          </div>
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>Phone</label>
              <input v-model="mover.phone"
                     type="text"
                     class="form-control"
                     @keydown="maskPhone($event)"
                     placeholder="Enter Phone"
                     maxlength="14"
              />
            </div>
            <error-field :errors="errors" field="phone" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>Date of birth</label>
              <datepicker v-model="mover.date_of_birth"
                          name="date_of_birth"
                          placeholder="Select Date"
                          class="form-control"
                          :format="dateFormatter"
              />
            </div>
            <error-field :errors="errors" field="date_of_birth" />
          </div>
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap amount-wrap">
              <label>Hourly wage</label>
              <span class="dollar">$</span>
              <input type="text"
                     class="form-control"
                     v-model="mover.wage"
              />
            </div>
            <error-field :errors="errors" field="wage" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>State</label>
              <simple-select v-if="states.length"
                             v-model="mover.state_id"
                             :options="states"
                             placeholder="Select State"
              />
            </div>
          </div>
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>City</label>
              <input type="text"
                     class="form-control"
                     v-model="mover.city"
              />
            </div>
            <error-field :errors="errors" field="city" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>Zip</label>
              <input type="text"
                     class="form-control"
                     v-model="mover.zip"
              />
            </div>
            <error-field :errors="errors" field="zip" />
          </div>
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>Address 1</label>
              <input type="text"
                     class="form-control"
                     v-model="mover.address"
              />
            </div>
            <error-field :errors="errors" field="address" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>Address 2</label>
              <input type="text"
                     class="form-control"
                     v-model="mover.address2"
              />
            </div>
          </div>
          <div class="col-6 pl-1 pr-1">
            <div class="select-wrap">
              <label>Can this mover be a foreman?</label>
              <p class="px-3">
                <label class="switch-small">
                  <input type="checkbox"
                         v-model="mover.foreman"
                  />
                  <span class="slider round" />
                </label>
              </p>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 pl-1 pr-1">
            <div class="select-wrap">
              <label>Carrier</label>
              <simple-select v-model="mover.carrier_id"
                             v-if="carriers"
                             :options="carriers"
                             placeholder="Select Carrier"
              />
            </div>
            <error-field :errors="errors" field="carrier_id" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 pl-1 pr-1">
            <div class="select-wrap">
              <label>Timezone</label>
              <simple-select
                v-model="mover.timezone"
                :options="timezones"
                placeholder="Select time zone"
              />
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col">
            <button class="btn btn-primary float-right">Create</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import toastr from 'toastr';
import tippy from 'tippy.js';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';
import PhoneMask from '../../classes/PhoneMask';
import Date from '../../classes/Date';

export default {
  components: {
    Datepicker,
    ErrorField,
  },
  data: () => ({
    mover: {
      address2: '',
      address: '',
      carrier_id: 0,
      city: '',
      date_of_birth: '',
      description: '',
      email: '',
      first_name: '',
      foreman: false,
      last_name: '',
      password: '',
      password_confirmation: '',
      phone: '',
      showDropdown: false,
      ssn: '',
      ssn_verified: false,
      state: [
        {
          id: '',
        },
      ],
      state_id: null,
      status_id: 0,
      timezone: '',
      user_status_id: 0,
      username: '',
      zip: '',
    },
    phoneMask: new PhoneMask(),
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      carriers: state => state.carriers.carriers.data,
      states: state => state.values.states,
      timezones: state => state.timezones.timezones.data,
    }),
  },
  mounted() {
    this.$nextTick(() => {
      window.$('input').attr('autocomplete', 'no');
    });
    tippy('.popup', {
      placement: 'bottom',
      html: '#myTemplate',
    });
    this.getStates();
    this.getTimezones();
  },
  methods: {
    ...mapActions(['getTimezones', 'getStates']),
    create() {
      const mover = Object.assign({}, this.mover);
      axios
        .post(`movers`, { ...mover })
        .then(() => {
          toastr.success('Successfully created mover');
          this.$emit('update');
          this.$emit('cancel');
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    dateFormatter(date) {
      this.mover.date_of_birth = Date.formattedDate(date);
      return this.mover.date_of_birth;
    },
    maskPhone(event) {
      this.$nextTick(() => {
        this.$set(
          this.mover,
          'phone',
          this.phoneMask.maskedPhone(this.mover.phone.replace(/\D/g, '')),
        );
        this.clearError(event);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 18px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: -2px;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 10px;
  width: 10px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:focus + .slider {
  box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.check-field {
  border-bottom: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/movers/MoversCreate.vue